import {Icons} from '../../common/Icons.jsx'

export const iconsStatusMatcher = {
    REALIZOWANE: {
        icon: <Icons.progres size={28}/>,
        color: 'secondary',
    },
    PRZYJĘTY: {
        icon: <Icons.przyjety size={28}/>,
        color: 'info',
    },
    PRZYJĘTA: {
        icon: <Icons.przyjety size={28}/>,
        color: 'info',
    },
    W_EDYCJI: {
        icon: <Icons.edit size={28}/>,
        color: 'secondary',
    },

    DO_POPRAWY: {
        icon: <Icons.update size={28}/>,
        color: 'warning',
    },
    ZŁOŻONY: {
        icon: <Icons.zlozony size={28}/>,
        color: 'success',
    },
    ZŁOŻONA: {
        icon: <Icons.zlozony size={28}/>,
        color: 'success',
    },
    ZAKOŃCZONY: {
        icon: <Icons.zakonczony size={28}/>,
        color: 'success',
    },
    ZAKOŃCZONA: {
        icon: <Icons.zakonczony size={28}/>,
        color: 'success',
    },
    ANULOWANA: {
        icon: <Icons.cancel size={28}/>,
        color: 'danger',
    },
    ARCHIWALNA: {
        icon: <Icons.archive size={24}/>,
        color: 'dark',
    },
}